import React from 'react';
import { ZipFetchingStateButton } from 'src/components/selfService/features/OrderHistory/ZipDownload/buttons/ZipFetchingStateButton';
import { ZipGenerateStateButton } from 'src/components/selfService/features/OrderHistory/ZipDownload/buttons/ZipGenerateStateButton';
import { ZipGenerateStateWrapper } from 'src/components/selfService/features/OrderHistory/ZipDownload/buttons/ZipGenerateStateWrapper';
import { ZipFileStatus } from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';

export interface ButtonsControllerProps {
  status: ZipFileStatus;
  onOpen: () => void;
  isDisabled: boolean;
  getZIPFileFromS3: () => void;
  isDateRangeSelected: boolean;
}

export function ButtonsController({
  status,
  isDisabled,
  onOpen,
  isDateRangeSelected,
}: ButtonsControllerProps): JSX.Element {
  switch (status) {
    case ZipFileStatus.GENERATE:
    case ZipFileStatus.TOO_MANY:
      return (
        <ZipGenerateStateWrapper
          isDateRangeSelected={isDateRangeSelected}
          isDisabled={isDisabled}
          onClick={onOpen}
        />
      );
    case ZipFileStatus.FETCHING:
    case ZipFileStatus.COMPLETE:
      return <ZipFetchingStateButton onClick={onOpen} />;
    case ZipFileStatus.DOWNLOAD_SUCCESSFULLY:
      return (
        <ZipGenerateStateButton
          ariaLabel={ZipFileStatus.DOWNLOAD_SUCCESSFULLY}
          onClick={onOpen}
        />
      );

    default:
      return <></>;
  }
}
